/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditSettingCommand } from '../../models/edit-setting-command';
import { SettingDtoApiResponse } from '../../models/setting-dto-api-response';

export interface EditSettingAsync$Plain$Params {
  id: number;
      body?: EditSettingCommand
}

export function editSettingAsync$Plain(http: HttpClient, rootUrl: string, params: EditSettingAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SettingDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, editSettingAsync$Plain.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SettingDtoApiResponse>;
    })
  );
}

editSettingAsync$Plain.PATH = '/api/settings/{id}';
